// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__bre1t","container_fluid":"Footer_container_fluid__dyFqG"};